const isHeathrowPickup = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return upper.includes("HEATHROW") || upper.includes("LHR") || /\bTW6\b/i.test(upper);
};

const isLondonDropoff = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return (
    upper.includes("LONDON") ||
    upper.includes("WESTMINSTER") ||
    upper.includes("PADDINGTON") ||
    upper.includes("KENSINGTON") ||
    upper.includes("CHELSEA") ||
    upper.includes("CANARY WHARF") ||
    upper.includes("KING'S CROSS") ||
    upper.includes("KINGS CROSS") ||
    /\b(?:E|EC|N|NW|SE|SW|W|WC)\d{1,2}[A-Z]?\b/i.test(upper)
  );
};

const isMaidenheadPickup = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return (
    upper.includes("MAIDENHEAD") ||
    upper.includes("COOKHAM") ||
    upper.includes("TAPLOW") ||
    upper.includes("BRAY") ||
    upper.includes("FURZE PLATT") ||
    upper.includes("COX GREEN") ||
    upper.includes("PINKNEYS GREEN") ||
    /\bSL6\b/i.test(upper)
  );
};

const maidenheadReviews = {
  minibus: [
    ["Priya S.", "Our Maidenhead family group got one minibus to Heathrow instead of splitting across cars."],
    ["Daniel M.", "The quote was clear and the luggage questions helped us choose the right vehicle."],
    ["Aisha R.", "Useful Heathrow checks before booking, especially for an early SL6 airport run."],
  ],
  coach: [
    ["Rebecca H.", "Simple coach quote for our Maidenhead group travelling together to Heathrow."],
    ["Omar K.", "Good support for passenger numbers, luggage and terminal timing."],
    ["Lucy P.", "The route page made it easier to plan a larger airport transfer from Maidenhead."],
  ],
};

const maidenheadProofCards = [
  {
    eyebrow: "Licensed operators",
    title: "Registered and insured",
    body: "Maidenhead group airport transfers are handled by licensed private hire, minibus or PSV partners according to vehicle type.",
  },
  {
    eyebrow: "Airport aware",
    title: "Heathrow planning",
    body: "Terminal, flight, queue and M4 signals are shown before a group commits to the journey.",
  },
  {
    eyebrow: "Group travel",
    title: "Sized around luggage",
    body: "Quote requests start with vehicles suitable for families, schools, companies, hotels and event passengers.",
  },
];

const maidenheadChooseCards = [
  {
    title: "M4 corridor timing",
    body: "Maidenhead to Heathrow is usually direct, but M4 pressure, terminal choice and group loading time can affect the plan.",
  },
  {
    title: "One vehicle for the group",
    body: "Keep passengers, bags and pickup instructions together instead of splitting the journey across separate taxis.",
  },
  {
    title: "SL6 pickup coverage",
    body: "Start from Maidenhead town centre, Maidenhead station, Cookham, Bray, Taplow, Furze Platt, Cox Green and nearby SL6 addresses.",
  },
  {
    title: "Fixed quote flow",
    body: "Enter the route once, compare available group vehicles and continue through the same booking path.",
  },
];

const maidenheadRouteContentCards = [
  {
    title: "Maidenhead pickup coverage",
    body: "Common pickups include SL6 homes, Maidenhead railway station, Bray hotels, Taplow, Cookham, Furze Platt, Cox Green and local business locations.",
  },
  {
    title: "Heathrow terminal drop-offs",
    body: "Use Heathrow Airport or choose Terminal 2, 3, 4 or 5. Terminal choice can affect approach roads, unload time and group meet-up planning.",
  },
  {
    title: "Group luggage planning",
    body: "Airport groups should allow space for suitcases, pushchairs, school bags, sports kit, event equipment or hotel guest luggage.",
  },
  {
    title: "M4 and local road context",
    body: "Most journeys use the M4 corridor towards Heathrow, with live checks helping flag road pressure before travel.",
  },
  {
    title: "Hotels and business groups",
    body: "Useful for Maidenhead hotels, riverside venues, business travellers, school trips and larger family departures.",
  },
  {
    title: "Minibus or coach choice",
    body: "Minibus works well for 8 to 16 passengers. For larger school, corporate or tour groups, the coach variant supports bigger vehicles.",
  },
];

const maidenheadFaqItems = [
  {
    question: "How long does Maidenhead to Heathrow take by minibus?",
    answer: "Many Maidenhead to Heathrow journeys are around 25 to 45 minutes, but terminal choice, M4 traffic, pickup loading and time of day can change the plan.",
  },
  {
    question: "Can we book from Cookham, Bray or Taplow?",
    answer: "Yes. This route page supports Maidenhead-area pickups including Cookham, Bray, Taplow, Furze Platt, Cox Green and nearby SL6 postcodes.",
  },
  {
    question: "Do you cover all Heathrow terminals?",
    answer: "Yes. Enter Heathrow Airport or a specific terminal. Terminal 2, 3, 4 and 5 journeys can be planned through the quote flow.",
  },
  {
    question: "Should we choose a minibus or coach?",
    answer: "Use a minibus for typical 8 to 16 passenger groups. For 25+ passengers, use the Maidenhead to Heathrow coach route so the quote starts with larger vehicle options.",
  },
];

const isWindsorPickup = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return (
    upper.includes("WINDSOR") ||
    upper.includes("ETON") ||
    upper.includes("OLD WINDSOR") ||
    upper.includes("DATCHET") ||
    upper.includes("LEGOLAND") ||
    upper.includes("CLEWER") ||
    upper.includes("DEDWORTH") ||
    upper.includes("ASCOT") ||
    /\bSL4\b/i.test(upper)
  );
};

const windsorReviews = {
  minibus: [
    ["Nadia P.", "Our Windsor hotel group used one minibus to Heathrow and kept everyone together."],
    ["George T.", "Helpful for luggage and children after a LEGOLAND stay before flying from Heathrow."],
    ["Maya L.", "Clear quote flow from Windsor Castle area to the Heathrow terminal we needed."],
  ],
  coach: [
    ["Helen B.", "Good coach planning for a Windsor group heading to Heathrow after an event."],
    ["Karan S.", "The route page covered passenger numbers, bags and terminal timing clearly."],
    ["Sophie R.", "Useful support for a larger school group travelling from Windsor to Heathrow."],
  ],
};

const windsorProofCards = [
  {
    eyebrow: "Licensed operators",
    title: "Registered and insured",
    body: "Windsor group airport transfers are handled by licensed private hire, minibus or PSV partners according to vehicle type.",
  },
  {
    eyebrow: "Airport aware",
    title: "Heathrow planning",
    body: "Terminal, flight, queue and M4 or M25 signals are shown before a group commits to the journey.",
  },
  {
    eyebrow: "Visitor routes",
    title: "Built for hotels and attractions",
    body: "Quote requests cover Windsor hotels, Castle visitors, LEGOLAND stays, Eton events and group airport departures.",
  },
];

const windsorChooseCards = [
  {
    title: "Short airport corridor",
    body: "Windsor is close to Heathrow, but terminal choice, local pickup streets and group loading can still affect the plan.",
  },
  {
    title: "One vehicle for the group",
    body: "Keep passengers, bags, children and pickup instructions together instead of splitting the journey across separate taxis.",
  },
  {
    title: "SL4 pickup coverage",
    body: "Start from Windsor town centre, Eton, Old Windsor, Datchet, Clewer, Dedworth, LEGOLAND hotels and nearby SL4 addresses.",
  },
  {
    title: "Useful for visitor itineraries",
    body: "Works well after Windsor Castle visits, LEGOLAND stays, riverside hotels, weddings, school trips and corporate events.",
  },
];

const windsorRouteContentCards = [
  {
    title: "Windsor pickup coverage",
    body: "Common pickups include Windsor town centre, Windsor & Eton Central, Windsor & Eton Riverside, Eton, Old Windsor, Datchet, Clewer, Dedworth and SL4 hotels.",
  },
  {
    title: "Windsor Castle visitor groups",
    body: "Groups visiting Windsor Castle often need a timed airport transfer after checkout, a rail connection or a planned Castle itinerary.",
    links: [{ to: "/windsor-castle-budget-planner", label: "Open Windsor Castle planner" }],
  },
  {
    title: "LEGOLAND and family luggage",
    body: "Family groups leaving LEGOLAND or nearby hotels often need space for suitcases, pushchairs, park bags and tired children after checkout.",
    links: [{ to: "/legoland-budget-planner", label: "Open LEGOLAND planner" }],
  },
  {
    title: "Heathrow terminal drop-offs",
    body: "Use Heathrow Airport or choose Terminal 2, 3, 4 or 5. Terminal choice can affect approach roads, unload time and group meet-up planning.",
  },
  {
    title: "M4, M25 and local streets",
    body: "The route may use the M4, M25, A308 or local Windsor roads depending on pickup point and terminal. Live checks help flag pressure before travel.",
  },
  {
    title: "Minibus or coach choice",
    body: "Minibus works well for 8 to 16 passengers. For larger school, corporate, wedding or tour groups, the coach variant supports bigger vehicles.",
  },
];

const windsorFaqItems = [
  {
    question: "How long does Windsor to Heathrow take by minibus?",
    answer: "Many Windsor to Heathrow journeys are around 15 to 35 minutes, but terminal choice, M4 or M25 traffic, hotel loading and time of day can change the plan.",
  },
  {
    question: "Can we book from Eton, Datchet or Old Windsor?",
    answer: "Yes. This route page supports Windsor-area pickups including Eton, Old Windsor, Datchet, Clewer, Dedworth, LEGOLAND hotels and nearby SL4 postcodes.",
  },
  {
    question: "Can you collect from Windsor Castle or LEGOLAND hotels?",
    answer: "Yes. Enter the exact pickup point, hotel or postcode in the quote form. For busy visitor areas, add clear pickup notes during booking.",
  },
  {
    question: "Should we choose a minibus or coach?",
    answer: "Use a minibus for typical 8 to 16 passenger groups. For 25+ passengers, use the Windsor to Heathrow coach route so the quote starts with larger vehicle options.",
  },
];

const isAscotPickup = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return (
    upper.includes("ASCOT") ||
    upper.includes("ROYAL ASCOT") ||
    upper.includes("ASCOT RACECOURSE") ||
    upper.includes("SUNNINGHILL") ||
    upper.includes("SUNNINGDALE") ||
    upper.includes("CHEAPSIDE") ||
    upper.includes("LAPS") ||
    upper.includes("LAPLANDUK") ||
    /\bSL5\b/i.test(upper)
  );
};

const ascotReviews = {
  minibus: [
    ["Leah M.", "Our Ascot hotel group used one minibus to Heathrow and avoided splitting luggage across taxis."],
    ["Tom B.", "Helpful for a race day group heading back to Heathrow with bags and tight timing."],
    ["Rina S.", "Clear pickup defaults and sensible Heathrow checks for an early flight after Ascot."],
  ],
  coach: [
    ["Patrick H.", "Good coach planning for a corporate group travelling from Ascot to Heathrow."],
    ["Mariam A.", "The route page made passenger numbers, luggage and terminal timing easy to plan."],
    ["Julia C.", "Useful support for a larger Royal Ascot group needing an airport transfer."],
  ],
};

const ascotProofCards = [
  {
    eyebrow: "Licensed operators",
    title: "Registered and insured",
    body: "Ascot group airport transfers are handled by licensed private hire, minibus or PSV partners according to vehicle type.",
  },
  {
    eyebrow: "Airport aware",
    title: "Heathrow planning",
    body: "Terminal, flight, queue and M4 or M25 signals are shown before a group commits to the journey.",
  },
  {
    eyebrow: "Event ready",
    title: "Race day and hospitality groups",
    body: "Quote requests support Royal Ascot, racecourse hospitality, hotels, corporate groups and luggage-heavy airport departures.",
  },
];

const ascotChooseCards = [
  {
    title: "Racecourse timing matters",
    body: "Ascot to Heathrow can be straightforward, but race day crowds, hotel loading and local road closures can change pickup timing.",
  },
  {
    title: "One vehicle for the group",
    body: "Keep guests, luggage, race day outfits and pickup notes together instead of splitting the journey across separate taxis.",
  },
  {
    title: "SL5 pickup coverage",
    body: "Start from Ascot Racecourse, Ascot town centre, Sunninghill, Sunningdale, Cheapside, LaplandUK-area stays and nearby SL5 addresses.",
  },
  {
    title: "Built for event departures",
    body: "Useful for Royal Ascot, hospitality packages, business groups, hotel checkouts, weddings and post-event airport transfers.",
  },
];

const ascotRouteContentCards = [
  {
    title: "Ascot pickup coverage",
    body: "Common pickups include Ascot Racecourse, Ascot High Street, Sunninghill, Sunningdale, Cheapside, SL5 hotels and nearby private addresses.",
  },
  {
    title: "Royal Ascot 2026 context",
    body: "Royal Ascot 2026 runs from Tuesday 16 June to Saturday 20 June, with five days of racing, style, hospitality and large group movement around the racecourse.",
  },
  {
    title: "Enclosures and group experiences",
    body: "Windsor Enclosure, Queen Anne Enclosure, Royal Enclosure guests, party packages and hospitality bookings can need different pickup points and timings.",
  },
  {
    title: "Heathrow terminal drop-offs",
    body: "Use Heathrow Airport or choose Terminal 2, 3, 4 or 5. Terminal choice can affect approach roads, unload time and group meet-up planning.",
  },
  {
    title: "Race day luggage and outfits",
    body: "Airport groups should allow space for suitcases, hats, garment bags, hospitality items, pushchairs or event equipment.",
  },
  {
    title: "Minibus or coach choice",
    body: "Minibus works well for 8 to 16 passengers. For 25+ passengers, corporate hospitality or larger race day groups, the coach variant supports bigger vehicles.",
  },
];

const ascotFaqItems = [
  {
    question: "How long does Ascot to Heathrow take by minibus?",
    answer: "Many Ascot to Heathrow journeys are around 25 to 45 minutes, but terminal choice, M4 or M25 traffic, race day crowds and hotel loading can change the plan.",
  },
  {
    question: "Can we book from Ascot Racecourse after Royal Ascot?",
    answer: "Yes. Enter the exact pickup point or nearby hotel in the quote form. For Royal Ascot 2026 dates, allow extra time for crowds, walking routes and event traffic.",
  },
  {
    question: "Do you cover Sunninghill and Sunningdale?",
    answer: "Yes. This route page supports Ascot-area pickups including Sunninghill, Sunningdale, Cheapside, LaplandUK-area stays and nearby SL5 postcodes.",
  },
  {
    question: "Should we choose a minibus or coach?",
    answer: "Use a minibus for typical 8 to 16 passenger groups. For 25+ passengers, use the Ascot to Heathrow coach route so the quote starts with larger vehicle options.",
  },
];

const isHenleyPickup = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return (
    upper.includes("HENLEY") ||
    upper.includes("HENLEY-ON-THAMES") ||
    upper.includes("HENLEY ON THAMES") ||
    upper.includes("REGATTA") ||
    upper.includes("FAWLEY") ||
    upper.includes("TEMPLE ISLAND") ||
    upper.includes("REMENHAM") ||
    upper.includes("WARGRAVE") ||
    upper.includes("TWYFORD") ||
    upper.includes("SONNING") ||
    upper.includes("MARLOW") ||
    /\bRG9\b/i.test(upper)
  );
};

const henleyReviews = {
  minibus: [
    ["Laura B.", "Our Henley Regatta group used one minibus to Heathrow and avoided splitting bags across taxis."],
    ["Samir K.", "Helpful for a town centre pickup after a riverside weekend before flying from Heathrow."],
    ["Megan T.", "Clear quote flow from Henley-on-Thames to T5 with sensible luggage questions."],
  ],
  coach: [
    ["Charles R.", "Good coach planning for a larger Henley group heading to Heathrow after the Regatta."],
    ["Nadia P.", "The page made passenger numbers, bags and pickup timing around Henley much easier."],
    ["Imran H.", "Useful support for a company group travelling from Henley to Heathrow together."],
  ],
};

const henleyProofCards = [
  {
    eyebrow: "Licensed operators",
    title: "Registered and insured",
    body: "Henley group airport transfers are handled by licensed private hire, minibus or PSV partners according to vehicle type.",
  },
  {
    eyebrow: "Airport aware",
    title: "Heathrow planning",
    body: "Terminal, flight, queue, M4 and rail signals are shown before a group commits to the journey.",
  },
  {
    eyebrow: "Event ready",
    title: "Regatta and riverside groups",
    body: "Quote requests support Henley Royal Regatta, town centre pickups, hotels, hospitality, schools and luggage-heavy departures.",
  },
];

const henleyChooseCards = [
  {
    title: "Regatta timing matters",
    body: "Henley to Heathrow can be direct, but event crowds, riverside walking routes, town centre one-way flow and pickup loading can change timing.",
  },
  {
    title: "One vehicle for the group",
    body: "Keep passengers, luggage, event outfits and pickup notes together instead of splitting the journey across separate taxis.",
  },
  {
    title: "RG9 pickup coverage",
    body: "Start from Henley-on-Thames, Henley station, the town centre, riverside hotels, Remenham, Fawley Meadows, Wargrave, Twyford and nearby RG9 addresses.",
  },
  {
    title: "Built for event departures",
    body: "Useful for Henley Royal Regatta, hospitality guests, school crews, rowing clubs, hotel checkouts, weddings and post-event airport transfers.",
  },
];

const henleyRouteContentCards = [
  {
    title: "Henley pickup coverage",
    body: "Common pickups include Henley town centre, Henley-on-Thames station, riverside hotels, Remenham, Fawley Meadows, Temple Island access points, Wargrave and nearby RG9 addresses.",
  },
  {
    title: "Henley Royal Regatta 2026 context",
    body: "The 2026 Regatta is provisionally raced from Tuesday 30 June to Sunday 5 July, with qualifying races on Friday 26 June and the draw on Saturday 27 June.",
  },
  {
    title: "Racing and enclosure timing",
    body: "Provisional racing starts around 09:00 on most days, 09:30 on Tuesday and 10:50 on Sunday. Enclosures usually open 30 minutes before racing.",
  },
  {
    title: "Drop-off and walking routes",
    body: "During Regatta, the main taxi drop-off is usually around the A4130, a short walk from the Enclosures. Henley town centre is also a practical pickup point.",
  },
  {
    title: "Car park and coach context",
    body: "Official car parks open daily from 07:30 and close at 21:00, with no overnight parking. Event guidance says official car parks are not suitable for coaches, caravans, motorbikes or commercial vehicles.",
  },
  {
    title: "Heathrow terminal drop-offs",
    body: "Use Heathrow Airport or choose Terminal 2, 3, 4 or 5. Terminal choice can affect approach roads, unload time and group meet-up planning.",
  },
];

const henleyFaqItems = [
  {
    question: "How long does Henley to Heathrow take by minibus?",
    answer: "Many Henley-on-Thames to Heathrow journeys are around 45 to 70 minutes, but terminal choice, M4 or M40 routing, Regatta traffic, pickup loading and time of day can change the plan.",
  },
  {
    question: "Can we book from Henley Royal Regatta?",
    answer: "Yes. Enter the exact pickup point, hotel, town centre location or postcode in the quote form. For Regatta dates, allow extra time for walking routes, crowds and traffic flow.",
  },
  {
    question: "Do you cover Wargrave, Twyford and Remenham?",
    answer: "Yes. This route page supports Henley-area pickups including Remenham, Fawley Meadows, Wargrave, Twyford, Sonning, Marlow and nearby RG9 addresses.",
  },
  {
    question: "Should we choose a minibus or coach?",
    answer: "Use a minibus for typical 8 to 16 passenger groups. For 25+ passengers, use the Henley to Heathrow coach route so the quote starts with larger vehicle options.",
  },
];

export const groupRouteConfigs = {
  "heathrow-to-london": {
    configs: {
      minibus: {
        brand: "MinibusGrab",
        domain: "https://www.minibusgrab.com",
        className: "minibusgrab-v2-home",
        vehicle: "minibus",
        path: "/heathrow-to-london-minibus",
        title: "Heathrow to London Minibus Hire | 8 to 16 Seater Transfers",
        description:
          "Book Heathrow to London minibus hire for families, hotels, teams and groups. 8 to 16 seater options, live Heathrow status and London route intelligence.",
        keywords:
          "Heathrow to London minibus, London minibus from Heathrow, 8 seater Heathrow London, 16 seater Heathrow London, Heathrow group transfer",
        h1: "Heathrow to London minibus hire with live route intelligence",
        intro:
          "Fixed-price group transfers from Heathrow Terminals 2 to 5 to Central and Greater London, planned around flight arrivals, luggage, M4 traffic and London journey conditions.",
        quoteLabel: "Get Minibus Quote",
        passengers: 8,
        bags: 0,
        resultPath: "/minibus-results",
        resultQuery: "vehicles=nine,fourteen",
        seats: "8 to 16 seaters",
        fleet: ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Luggage-ready licensed partner options"],
      },
      coach: {
        brand: "CheapCoachGrab",
        domain: "https://www.cheapcoachgrab.com",
        className: "coachgrab-v2-home",
        vehicle: "coach",
        path: "/heathrow-to-london-coach",
        title: "Heathrow to London Coach Hire | 25 to 53 Seater Transfers",
        description:
          "Book Heathrow to London coach hire for schools, companies, tours and large airport groups. 25 to 53 seater options with live Heathrow and route intelligence.",
        keywords:
          "Heathrow to London coach, London coach hire from Heathrow, 25 seater Heathrow London, 49 seater Heathrow London, airport coach transfer",
        h1: "Heathrow to London coach hire planned with live intelligence",
        intro:
          "Coach transfers from Heathrow terminals to Central and Greater London for tour, school, corporate and hotel groups, with luggage, loading access and route timing considered.",
        quoteLabel: "Get Coach Quote",
        passengers: 25,
        bags: 0,
        resultPath: "/coach-results",
        resultQuery: "vehicle=twentyfive",
        seats: "25 to 53 seaters",
        fleet: ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"],
      },
    },
    route: {
      routeKey: "heathrow-london",
      liveStripVariant: "heathrow-london",
      pageClassName: "heathrow-london-v2",
      heroEyebrow: "Heathrow to London route",
      metrics: ["Terminals 2-5", "35-90 min typical", "__SEATS__", "M4 + London live checks"],
      areas: ["Heathrow Airport", "Paddington", "Kensington", "Westminster", "King's Cross", "Canary Wharf"],
      seo: {
        routeName: "Heathrow to London group transfer",
        serviceType: "Heathrow to London minibus and coach transfer",
        areaServed: ["Heathrow Airport", "Central London", "West London", "North London", "East London"],
      },
      trustCards: [
        {
          eyebrow: "Licensed operators",
          title: "Registered and insured",
          body: "Licensed minibus and PSV partners for airport-to-London group journeys.",
        },
        {
          eyebrow: "Arrival aware",
          title: "Flight, terminal and route checks",
          body: "Heathrow arrival context and London road conditions are considered before travel.",
        },
      ],
      quote: {
        formId: "heathrow-london-route-quote",
        pickupDefault: "Heathrow Airport",
        dropoffDefault: "Central London",
        pickupAriaLabel: "Heathrow terminal or pickup point",
        dropoffAriaLabel: "London drop-off postcode or address",
        pickupPlaceholder: "Enter Heathrow terminal or pickup point",
        dropoffPlaceholder: "Enter London postcode, hotel or address",
        validatePickup: isHeathrowPickup,
        pickupError: "This route page starts at Heathrow. Please enter Heathrow Airport, LHR, TW6 or a Heathrow terminal.",
        validateDropoff: isLondonDropoff,
        dropoffError: "This route page is for London destinations. Please enter a London postcode, hotel or address.",
        genericError:
          "We could not calculate a quote for this Heathrow to London journey. Please check the details and try again.",
      },
      compactStatusTitle: "Heathrow to London live checks",
      reviews: {
        minibus: [
          ["Martin R.", "One minibus kept our family and luggage together from Heathrow to our London hotel."],
          ["Aisha K.", "Clear quote, useful arrival checks and enough room for the whole group."],
          ["Daniel P.", "Much simpler than splitting our Heathrow arrival across several cars."],
        ],
        coach: [
          ["Rachel T.", "The coach quote covered our Heathrow terminal, luggage and London loading point clearly."],
          ["Imran S.", "Useful planning for a large company group arriving together at Heathrow."],
          ["Claire B.", "The route and airport checks helped with our school group's London transfer."],
        ],
      },
      proofCards: [
        { eyebrow: "Airport pickup", title: "Terminal-aware planning", body: "Terminals 2, 3, 4 and 5 have different meeting points and approach roads." },
        { eyebrow: "London coverage", title: "Hotels, venues and stations", body: "Drop-offs can cover Central London hotels, rail stations, venues and Greater London addresses." },
        { eyebrow: "Group travel", title: "Passengers and luggage together", body: "Choose capacity for suitcases, pushchairs, equipment and the full travelling group." },
      ],
      chooseTitle: "Built for groups arriving at Heathrow",
      chooseCards: [
        { title: "One airport pickup", body: "Keep the group together after baggage reclaim instead of coordinating several vehicles." },
        { title: "London timing varies", body: "M4, A4, M25 and cross-London congestion can change journey time substantially." },
        { title: "Hotel and venue access", body: "Exact entrances, loading restrictions and coach access matter in busy London locations." },
        { title: "Fixed quote flow", body: "Enter the Heathrow terminal and London destination once, then continue through the group booking path." },
      ],
      routeContentCards: [
        { title: "Heathrow terminal pickups", body: "Use Heathrow Airport or specify Terminal 2, 3, 4 or 5 so the pickup plan starts from the correct arrivals area." },
        { title: "Central and West London", body: "Popular destinations include Paddington, Kensington, Chelsea, Westminster, Victoria, Mayfair and Hammersmith." },
        { title: "North and East London", body: "Groups can continue to King's Cross, Camden, Stratford, Canary Wharf and other Greater London destinations." },
        { title: "Journey time", body: "Many transfers take around 35 to 90 minutes, but peak traffic and the final London postcode can extend the journey." },
        { title: "Flight and luggage planning", body: "Allow for baggage reclaim, terminal meeting arrangements and enough luggage capacity for the selected vehicle." },
        { title: "Minibus or coach", body: "Minibuses suit 8 to 16 passengers; coaches support larger tour, school, corporate and event groups." },
      ],
      faqItems: [
        { question: "How long does Heathrow to London take?", answer: "Many journeys take 35 to 90 minutes. Terminal, destination postcode, time of day and London traffic all affect the result." },
        { question: "Do you collect from every Heathrow terminal?", answer: "Yes. Enter Terminal 2, 3, 4 or 5 and provide the flight and meeting details during booking." },
        { question: "Can you drop at London hotels and stations?", answer: "Yes. Enter the exact hotel, station, venue or postcode. Large coaches may require an agreed legal loading point." },
        { question: "Should we choose a minibus or coach?", answer: "Use a minibus for typical 8 to 16 passenger groups. Choose the coach page for 25 or more passengers or larger organised groups." },
      ],
      pricePreviewTitle: (vehicle) => `Heathrow to London ${vehicle} previews`,
      routeOverviewTitle: "Heathrow to London route notes",
      routeOverviewIntro:
        "The Heathrow to London corridor ranges from short West London transfers to longer cross-city journeys. Terminal, destination, group luggage and loading access all need to be clear before travel.",
      vehicleContextTitle: (brand) => `${brand} options from Heathrow to London`,
      faqEyebrow: "Heathrow / London FAQ",
      faqTitle: "Common questions before booking",
      support: {
        title: "Need help planning a Heathrow to London group transfer?",
        body: "Use the quote form first, or contact support for flight arrivals, multiple stops, hotel access, large luggage loads or coach loading questions.",
        nudgeText: "Need Heathrow to London group help?",
      },
    },
  },
  "maidenhead-to-heathrow": {
    configs: {
      minibus: {
        brand: "MinibusGrab",
        domain: "https://www.minibusgrab.com",
        className: "minibusgrab-v2-home",
        vehicle: "minibus",
        path: "/maidenhead-to-heathrow-minibus",
        title: "Maidenhead to Heathrow Minibus Hire | 8 to 16 Seater Group Transfers",
        description:
          "Book Maidenhead to Heathrow minibus hire for families, hotels, teams and groups. 8 to 16 seater options, live Heathrow status and fixed-price quote flow.",
        keywords:
          "Maidenhead to Heathrow minibus, Heathrow minibus Maidenhead, 8 seater Maidenhead to Heathrow, 16 seater Maidenhead to Heathrow, SL6 airport minibus",
        h1: "Maidenhead to Heathrow minibus hire with live airport intelligence",
        intro:
          "Fixed-price group transfers from Maidenhead, SL6, Cookham, Bray and Taplow to Heathrow terminals, planned with live airport, M4 route and rail disruption signals.",
        quoteLabel: "Get Minibus Quote",
        passengers: 8,
        bags: 0,
        resultPath: "/minibus-results",
        resultQuery: "vehicles=nine,fourteen",
        seats: "8 to 16 seaters",
        fleet: ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Licensed PSV partner options"],
      },
      coach: {
        brand: "CheapCoachGrab",
        domain: "https://www.cheapcoachgrab.com",
        className: "coachgrab-v2-home",
        vehicle: "coach",
        path: "/maidenhead-to-heathrow-coach",
        title: "Maidenhead to Heathrow Coach Hire | 25 to 53 Seater Airport Transfers",
        description:
          "Book Maidenhead to Heathrow coach hire for schools, companies, hotels and large groups. 25 to 53 seater options, live Heathrow status and route intelligence.",
        keywords:
          "Maidenhead to Heathrow coach, Heathrow coach hire Maidenhead, 25 seater Maidenhead to Heathrow, 49 seater coach Heathrow, SL6 airport coach hire",
        h1: "Maidenhead to Heathrow coach hire planned with live intelligence",
        intro:
          "Coach transfers from Maidenhead, Cookham, Bray, Taplow and nearby hotels to Heathrow, with route planning around M4 pressure, terminal status and group timing.",
        quoteLabel: "Get Coach Quote",
        passengers: 25,
        bags: 0,
        resultPath: "/coach-results",
        resultQuery: "vehicle=twentyfive",
        seats: "25 to 53 seaters",
        fleet: ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"],
      },
    },
    route: {
      routeKey: "maidenhead",
      liveStripVariant: "maidenhead",
      pageClassName: "maidenhead-heathrow-v2",
      heroEyebrow: "Maidenhead to Heathrow route",
      metrics: ["SL6 + nearby villages", "25-45 min typical", "__SEATS__", "M4 + Heathrow live checks"],
      areas: ["Maidenhead", "Cookham", "Bray", "Taplow", "Heathrow Airport"],
      seo: {
        routeName: "Maidenhead to Heathrow group transfer",
        serviceType: "Heathrow group airport transfer",
        areaServed: ["Maidenhead", "Cookham", "Bray", "Taplow", "Heathrow Airport"],
      },
      trustCards: [
        {
          eyebrow: "GOV.UK registered",
          title: "Licensed operators",
          body: "Licensed and insured partners for group airport journeys.",
        },
        {
          eyebrow: "Live Heathrow status",
          title: "Road, rail, flight and queues",
          body: "Route context is shown before the booking decision.",
        },
      ],
      quote: {
        formId: "maidenhead-heathrow-route-quote",
        pickupDefault: "Maidenhead, SL6",
        dropoffDefault: "Heathrow Airport",
        pickupAriaLabel: "Maidenhead pickup postcode or address",
        dropoffAriaLabel: "Heathrow drop-off postcode or terminal",
        pickupPlaceholder: "Enter Maidenhead pickup postcode or address",
        dropoffPlaceholder: "Enter Heathrow terminal or dropoff",
        validatePickup: isMaidenheadPickup,
        pickupError: "This route page is for Maidenhead pickups. Please use an SL6 postcode or Maidenhead-area address.",
        genericError:
          "We could not calculate a quote for this Maidenhead to Heathrow journey. Please check the details and try again.",
      },
      compactStatusTitle: "Maidenhead to Heathrow checks",
      detailedStatusTitle: (vehicleLabel) => `Heathrow checks for Maidenhead to Heathrow ${vehicleLabel} journeys`,
      detailedStatusIntro:
        "Roads, rail, flights, terminal pressure, queues and weather are grouped into a practical preview before the group commits to a quote.",
      reviews: maidenheadReviews,
      proofCards: maidenheadProofCards,
      chooseTitle: "Built for Maidenhead groups heading to Heathrow",
      chooseCards: maidenheadChooseCards,
      routeContentCards: maidenheadRouteContentCards,
      faqItems: maidenheadFaqItems,
      pricePreviewTitle: (vehicle) => `Maidenhead to Heathrow ${vehicle} previews`,
      routeOverviewTitle: "Maidenhead to Heathrow route notes",
      routeOverviewIntro:
        "Maidenhead is a regular M4 corridor pickup for Heathrow, but terminal choice, group luggage, station pickups and road pressure still matter. This page keeps the route specific so users can understand the journey before they quote.",
      vehicleContextTitle: (brand) => `${brand} options for Maidenhead to Heathrow`,
      faqEyebrow: "Maidenhead / LHR FAQ",
      faqTitle: "Common questions before booking",
      support: {
        title: "Need help planning a Maidenhead to Heathrow group transfer?",
        body:
          "Use the quote form first, or contact support for multi-stop, hotel, school, event or luggage-heavy journeys.",
        nudgeText: "Need Maidenhead group transfer help?",
      },
    },
  },
  "windsor-to-heathrow": {
    configs: {
      minibus: {
        brand: "MinibusGrab",
        domain: "https://www.minibusgrab.com",
        className: "minibusgrab-v2-home",
        vehicle: "minibus",
        path: "/windsor-to-heathrow-minibus",
        title: "Windsor to Heathrow Minibus Hire | 8 to 16 Seater Airport Transfers",
        description:
          "Book Windsor to Heathrow minibus hire for families, hotels, Castle visitors, LEGOLAND groups and teams. 8 to 16 seater options, live Heathrow status and fixed-price quote flow.",
        keywords:
          "Windsor to Heathrow minibus, Heathrow minibus Windsor, 8 seater Windsor to Heathrow, 16 seater Windsor to Heathrow, SL4 airport minibus, LEGOLAND to Heathrow minibus",
        h1: "Windsor to Heathrow minibus hire with live airport intelligence",
        intro:
          "Fixed-price group transfers from Windsor, Eton, Old Windsor, Datchet, LEGOLAND and SL4 hotels to Heathrow terminals, planned with live airport and road signals.",
        quoteLabel: "Get Minibus Quote",
        passengers: 8,
        bags: 0,
        resultPath: "/minibus-results",
        resultQuery: "vehicles=nine,fourteen",
        seats: "8 to 16 seaters",
        fleet: ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Licensed PSV partner options"],
      },
      coach: {
        brand: "CheapCoachGrab",
        domain: "https://www.cheapcoachgrab.com",
        className: "coachgrab-v2-home",
        vehicle: "coach",
        path: "/windsor-to-heathrow-coach",
        title: "Windsor to Heathrow Coach Hire | 25 to 53 Seater Airport Transfers",
        description:
          "Book Windsor to Heathrow coach hire for schools, companies, hotels, Castle visitors and large groups. 25 to 53 seater options, live Heathrow status and route intelligence.",
        keywords:
          "Windsor to Heathrow coach, Heathrow coach hire Windsor, 25 seater Windsor to Heathrow, 49 seater coach Heathrow, SL4 airport coach hire, LEGOLAND to Heathrow coach",
        h1: "Windsor to Heathrow coach hire planned with live intelligence",
        intro:
          "Coach transfers from Windsor, Eton, Old Windsor, Datchet, LEGOLAND and nearby hotels to Heathrow, with route planning around terminal status and group timing.",
        quoteLabel: "Get Coach Quote",
        passengers: 25,
        bags: 0,
        resultPath: "/coach-results",
        resultQuery: "vehicle=twentyfive",
        seats: "25 to 53 seaters",
        fleet: ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"],
      },
    },
    route: {
      routeKey: "windsor",
      liveStripVariant: "windsor",
      pageClassName: "windsor-heathrow-v2",
      heroEyebrow: "Windsor to Heathrow route",
      metrics: ["SL4 + visitor hotspots", "15-35 min typical", "__SEATS__", "Heathrow live checks"],
      areas: ["Windsor", "Eton", "Old Windsor", "Datchet", "Heathrow Airport"],
      seo: {
        routeName: "Windsor to Heathrow group transfer",
        serviceType: "Heathrow group airport transfer",
        areaServed: ["Windsor", "Eton", "Old Windsor", "Datchet", "Heathrow Airport"],
      },
      trustCards: [
        {
          eyebrow: "GOV.UK registered",
          title: "Licensed operators",
          body: "Licensed and insured partners for group airport journeys.",
        },
        {
          eyebrow: "Live Heathrow status",
          title: "Road, rail, flight and queues",
          body: "Route context is shown before the booking decision.",
        },
      ],
      quote: {
        formId: "windsor-heathrow-route-quote",
        pickupDefault: "Windsor, SL4",
        dropoffDefault: "Heathrow Airport",
        pickupAriaLabel: "Windsor pickup postcode or address",
        dropoffAriaLabel: "Heathrow drop-off postcode or terminal",
        pickupPlaceholder: "Enter Windsor pickup postcode or address",
        dropoffPlaceholder: "Enter Heathrow terminal or dropoff",
        validatePickup: isWindsorPickup,
        pickupError: "This route page is for Windsor pickups. Please use an SL4 postcode or Windsor-area address.",
        genericError:
          "We could not calculate a quote for this Windsor to Heathrow journey. Please check the details and try again.",
      },
      compactStatusTitle: "Windsor to Heathrow checks",
      detailedStatusTitle: (vehicleLabel) => `Heathrow checks for Windsor to Heathrow ${vehicleLabel} journeys`,
      detailedStatusIntro:
        "Roads, rail, flights, terminal pressure, queues and weather are grouped into a practical preview before the group commits to a quote.",
      reviews: windsorReviews,
      proofCards: windsorProofCards,
      chooseTitle: "Built for Windsor groups heading to Heathrow",
      chooseCards: windsorChooseCards,
      routeContentCards: windsorRouteContentCards,
      faqItems: windsorFaqItems,
      pricePreviewTitle: (vehicle) => `Windsor to Heathrow ${vehicle} previews`,
      routeOverviewTitle: "Windsor to Heathrow route notes",
      routeOverviewIntro:
        "Windsor is close to Heathrow, but Castle visitor timing, LEGOLAND hotel checkouts, group luggage and local pickup streets still matter. This page keeps the route specific so users can understand the journey before they quote.",
      vehicleContextTitle: (brand) => `${brand} options for Windsor to Heathrow`,
      faqEyebrow: "Windsor / LHR FAQ",
      faqTitle: "Common questions before booking",
      support: {
        title: "Need help planning a Windsor to Heathrow group transfer?",
        body:
          "Use the quote form first, or contact support for multi-stop, hotel, school, Castle, LEGOLAND, event or luggage-heavy journeys.",
        nudgeText: "Need Windsor group transfer help?",
      },
    },
  },
  "ascot-to-heathrow": {
    configs: {
      minibus: {
        brand: "MinibusGrab",
        domain: "https://www.minibusgrab.com",
        className: "minibusgrab-v2-home",
        vehicle: "minibus",
        path: "/ascot-to-heathrow-minibus",
        title: "Ascot to Heathrow Minibus Hire | 8 to 16 Seater Airport Transfers",
        description:
          "Book Ascot to Heathrow minibus hire for Royal Ascot, racecourse groups, hotels, families and teams. 8 to 16 seater options, live Heathrow status and fixed-price quote flow.",
        keywords:
          "Ascot to Heathrow minibus, Royal Ascot minibus to Heathrow, Heathrow minibus Ascot, 8 seater Ascot to Heathrow, 16 seater Ascot to Heathrow, SL5 airport minibus",
        h1: "Ascot to Heathrow minibus hire with live airport intelligence",
        intro:
          "Fixed-price group transfers from Ascot, Ascot Racecourse, Sunninghill, Sunningdale and SL5 hotels to Heathrow terminals, planned with live airport and road signals.",
        quoteLabel: "Get Minibus Quote",
        passengers: 8,
        bags: 0,
        resultPath: "/minibus-results",
        resultQuery: "vehicles=nine,fourteen",
        seats: "8 to 16 seaters",
        fleet: ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Licensed PSV partner options"],
      },
      coach: {
        brand: "CheapCoachGrab",
        domain: "https://www.cheapcoachgrab.com",
        className: "coachgrab-v2-home",
        vehicle: "coach",
        path: "/ascot-to-heathrow-coach",
        title: "Ascot to Heathrow Coach Hire | 25 to 53 Seater Airport Transfers",
        description:
          "Book Ascot to Heathrow coach hire for Royal Ascot, schools, companies, hotels, racecourse hospitality and large groups. 25 to 53 seater options and live Heathrow status.",
        keywords:
          "Ascot to Heathrow coach, Royal Ascot coach to Heathrow, Heathrow coach hire Ascot, 25 seater Ascot to Heathrow, 49 seater coach Heathrow, SL5 airport coach hire",
        h1: "Ascot to Heathrow coach hire planned with live intelligence",
        intro:
          "Coach transfers from Ascot, Ascot Racecourse, Sunninghill, Sunningdale and nearby hotels to Heathrow, with route planning around event traffic, terminal status and group timing.",
        quoteLabel: "Get Coach Quote",
        passengers: 25,
        bags: 0,
        resultPath: "/coach-results",
        resultQuery: "vehicle=twentyfive",
        seats: "25 to 53 seaters",
        fleet: ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"],
      },
    },
    route: {
      routeKey: "ascot",
      liveStripVariant: "windsor",
      pageClassName: "ascot-heathrow-v2",
      heroEyebrow: "Ascot to Heathrow route",
      metrics: ["SL5 + racecourse pickups", "25-45 min typical", "__SEATS__", "Event + Heathrow live checks"],
      areas: ["Ascot", "Ascot Racecourse", "Sunninghill", "Sunningdale", "Heathrow Airport"],
      seo: {
        routeName: "Ascot to Heathrow group transfer",
        serviceType: "Heathrow group airport transfer",
        areaServed: ["Ascot", "Ascot Racecourse", "Sunninghill", "Sunningdale", "Heathrow Airport"],
      },
      trustCards: [
        {
          eyebrow: "GOV.UK registered",
          title: "Licensed operators",
          body: "Licensed and insured partners for group airport journeys.",
        },
        {
          eyebrow: "Live Heathrow status",
          title: "Road, rail, flight and queues",
          body: "Route context is shown before the booking decision.",
        },
      ],
      quote: {
        formId: "ascot-heathrow-route-quote",
        pickupDefault: "Ascot, SL5",
        dropoffDefault: "Heathrow Airport",
        pickupAriaLabel: "Ascot pickup postcode or address",
        dropoffAriaLabel: "Heathrow drop-off postcode or terminal",
        pickupPlaceholder: "Enter Ascot pickup postcode or address",
        dropoffPlaceholder: "Enter Heathrow terminal or dropoff",
        validatePickup: isAscotPickup,
        pickupError: "This route page is for Ascot pickups. Please use an SL5 postcode or Ascot-area address.",
        genericError:
          "We could not calculate a quote for this Ascot to Heathrow journey. Please check the details and try again.",
      },
      compactStatusTitle: "Ascot to Heathrow checks",
      detailedStatusTitle: (vehicleLabel) => `Heathrow checks for Ascot to Heathrow ${vehicleLabel} journeys`,
      detailedStatusIntro:
        "Roads, rail, flights, terminal pressure, queues, weather and event timing are grouped into a practical preview before the group commits to a quote.",
      reviews: ascotReviews,
      proofCards: ascotProofCards,
      chooseTitle: "Built for Ascot groups heading to Heathrow",
      chooseCards: ascotChooseCards,
      routeContentCards: ascotRouteContentCards,
      faqItems: ascotFaqItems,
      pricePreviewTitle: (vehicle) => `Ascot to Heathrow ${vehicle} previews`,
      routeOverviewTitle: "Ascot to Heathrow route notes",
      routeOverviewIntro:
        "Ascot is a regular Heathrow pickup for racecourse guests, hotel groups and SL5 residents. Royal Ascot dates add event movement, outfit luggage and hospitality timing, so this page keeps the route specific before users quote.",
      vehicleContextTitle: (brand) => `${brand} options for Ascot to Heathrow`,
      faqEyebrow: "Ascot / LHR FAQ",
      faqTitle: "Common questions before booking",
      support: {
        title: "Need help planning an Ascot to Heathrow group transfer?",
        body:
          "Use the quote form first, or contact support for Royal Ascot, racecourse, hotel, school, corporate, event or luggage-heavy journeys.",
        nudgeText: "Need Ascot group transfer help?",
      },
    },
  },
  "henley-to-heathrow": {
    configs: {
      minibus: {
        brand: "MinibusGrab",
        domain: "https://www.minibusgrab.com",
        className: "minibusgrab-v2-home",
        vehicle: "minibus",
        path: "/henley-to-heathrow-minibus",
        title: "Henley to Heathrow Minibus Hire | Regatta & Airport Transfers",
        description:
          "Book Henley to Heathrow minibus hire for Henley Royal Regatta, riverside hotels, rowing crews, families and groups. 8 to 16 seater options and live Heathrow status.",
        keywords:
          "Henley to Heathrow minibus, Henley Royal Regatta minibus, Heathrow minibus Henley, 8 seater Henley to Heathrow, 16 seater Henley to Heathrow, RG9 airport minibus",
        h1: "Henley to Heathrow minibus hire with live airport intelligence",
        intro:
          "Fixed-price group transfers from Henley-on-Thames, Regatta pickup points, riverside hotels, Wargrave and RG9 addresses to Heathrow terminals.",
        quoteLabel: "Get Minibus Quote",
        passengers: 8,
        bags: 0,
        resultPath: "/minibus-results",
        resultQuery: "vehicles=nine,fourteen",
        seats: "8 to 16 seaters",
        fleet: ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Licensed PSV partner options"],
      },
      coach: {
        brand: "CheapCoachGrab",
        domain: "https://www.cheapcoachgrab.com",
        className: "coachgrab-v2-home",
        vehicle: "coach",
        path: "/henley-to-heathrow-coach",
        title: "Henley to Heathrow Coach Hire | Regatta Group Airport Transfers",
        description:
          "Book Henley to Heathrow coach hire for Henley Royal Regatta, schools, companies, hospitality guests and large airport groups. 25 to 53 seater options.",
        keywords:
          "Henley to Heathrow coach, Henley Royal Regatta coach, Heathrow coach hire Henley, 25 seater Henley to Heathrow, 49 seater coach Heathrow, RG9 coach hire",
        h1: "Henley to Heathrow coach hire planned with live intelligence",
        intro:
          "Coach transfers from Henley-on-Thames, Regatta hospitality areas, riverside hotels, rowing clubs and nearby RG9 pickups to Heathrow.",
        quoteLabel: "Get Coach Quote",
        passengers: 25,
        bags: 0,
        resultPath: "/coach-results",
        resultQuery: "vehicle=twentyfive",
        seats: "25 to 53 seaters",
        fleet: ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"],
      },
    },
    route: {
      routeKey: "henley",
      liveStripVariant: "maidenhead",
      pageClassName: "henley-heathrow-v2",
      heroEyebrow: "Henley to Heathrow route",
      metrics: ["RG9 + Regatta pickups", "45-70 min typical", "__SEATS__", "Event + Heathrow live checks"],
      areas: ["Henley-on-Thames", "Henley Royal Regatta", "Remenham", "Wargrave", "Heathrow Airport"],
      seo: {
        routeName: "Henley to Heathrow group transfer",
        serviceType: "Heathrow group airport transfer",
        areaServed: ["Henley-on-Thames", "Remenham", "Wargrave", "Twyford", "Heathrow Airport"],
      },
      trustCards: [
        {
          eyebrow: "GOV.UK registered",
          title: "Licensed operators",
          body: "Licensed and insured partners for group airport journeys.",
        },
        {
          eyebrow: "Live Heathrow status",
          title: "Road, rail, flight and queues",
          body: "Route context is shown before the booking decision.",
        },
      ],
      quote: {
        formId: "henley-heathrow-route-quote",
        pickupDefault: "Henley-on-Thames, RG9",
        dropoffDefault: "Heathrow Airport",
        pickupAriaLabel: "Henley pickup postcode or address",
        dropoffAriaLabel: "Heathrow drop-off postcode or terminal",
        pickupPlaceholder: "Enter Henley pickup postcode or address",
        dropoffPlaceholder: "Enter Heathrow terminal or dropoff",
        validatePickup: isHenleyPickup,
        pickupError: "This route page is for Henley pickups. Please use an RG9 postcode or Henley-area address.",
        genericError:
          "We could not calculate a quote for this Henley to Heathrow journey. Please check the details and try again.",
      },
      compactStatusTitle: "Henley to Heathrow checks",
      detailedStatusTitle: (vehicleLabel) => `Heathrow checks for Henley to Heathrow ${vehicleLabel} journeys`,
      detailedStatusIntro:
        "Roads, rail, flights, terminal pressure, queues, weather and event timing are grouped into a practical preview before the group commits to a quote.",
      reviews: henleyReviews,
      proofCards: henleyProofCards,
      chooseTitle: "Built for Henley groups heading to Heathrow",
      chooseCards: henleyChooseCards,
      routeContentCards: henleyRouteContentCards,
      faqItems: henleyFaqItems,
      pricePreviewTitle: (vehicle) => `Henley to Heathrow ${vehicle} previews`,
      routeOverviewTitle: "Henley to Heathrow route notes",
      routeOverviewIntro:
        "Henley-on-Thames is a regular Heathrow pickup for Regatta guests, riverside hotels, crews, families and RG9 residents. Event dates add walking routes, one-way traffic and luggage planning, so this page keeps the route specific before users quote.",
      vehicleContextTitle: (brand) => `${brand} options for Henley to Heathrow`,
      faqEyebrow: "Henley / LHR FAQ",
      faqTitle: "Common questions before booking",
      support: {
        title: "Need help planning a Henley to Heathrow group transfer?",
        body:
          "Use the quote form first, or contact support for Regatta, rowing crew, hotel, school, corporate, event or luggage-heavy journeys.",
        nudgeText: "Need Henley group transfer help?",
      },
    },
  },
};

export default groupRouteConfigs;
